var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFilter)?_c('button',{staticClass:"btn btn-sm btn-gray-200",class:_vm.isOptionSelected ? 'border-dark' : '',staticStyle:{"border-radius":"10rem !important"},on:{"click":_vm.onClick}},[_c('span',{},[_vm._v(_vm._s(_vm.option.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }